<div class="bg-white" *ngIf="!isLoading; else loader">
  <div class="modal-header blue">
    <h4 class="fz-16 fw-demi-bold mb-0">
      <!-- {{ user ? "Edit User" : "Create New User"}} -->
      You Session Has Expired
    </h4>
  </div>

  <div class="modal-body fz-14">
    <div>
      You've been inactive for a while.
      <br />
      Choose 'Stay signed in' to continue or 'Signed Out' if you're done.
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button class="button-outline mr-3" (click)="logout()">Signed Out</button>
    <button class="button" (click)="refreshToken()">Stay signed in</button>
  </div>
</div>

<ng-template #loader>
  <loader style="height: 40px"></loader>
</ng-template>
